var render = function render(){var _vm=this,_c=_vm._self._c;return _c('line-chart',{attrs:{"hide-legend":"","labels":_vm.labels,"datasets":_vm.datasets,"chartType":'Baseline',"interval":_vm.interval,"jetton":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }